module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAASCAYAAABy+8PSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPZJREFUeNrs27EKglAUgOFTt6WWmiNIiAK33sRX8JV6g16hN6nJqTDaDE0XbRGzcoggaoq65//g4izn/GBlraqqxFau6w7qy7I+ngCvrerjB0GQ2nqDbcsHOCdyfMBrdsVaHc3T7XZ7MhyNWHPLlWUph314u2qlOvTJdCbGGErQYOxIuNuqvf225tkTObMmdACEDoDQARD61y3k/lsp8GijZS+0fOvu16fPXuOJ0xxCtwSRQ/Ve8BkdIHQAhA6A0H9dksRsgBKnWPesVb/rfv2jw7nIxZgOJVisyHPJspTQNTtGESWAR/c/txZelMF7q2ZXrHURYACYizC6V+b7+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RAPS.png
// module id = /XeW
// module chunks = 0